module.exports = "/_next/static/images/ae7fb269ce73a11d54420989a873e35a-mastercard-left-lg.jpg";